import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid } from "recharts";
import { inr, fmtDate } from "../lib/api";
import { short } from "./BooksChart";

export const DailyChart = ({ days, onSelect }) => {
  const data = [...days].reverse().map((d) => ({ ...d, label: fmtDate(d.date).slice(0, 5) }));
  return (
    <div className="rounded-2xl border border-line bg-surface p-4 sm:p-6 rise" data-testid="daily-chart">
      <h2 className="font-display text-base md:text-lg font-semibold mb-4">Daily Deposit &amp; Withdraw</h2>
      {data.length === 0 ? (
        <p className="text-sm text-muted-c py-10 text-center">No entries in this period</p>
      ) : (
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%" minWidth={200} minHeight={200}>
            <AreaChart data={data} onClick={(e) => e?.activeLabel && onSelect(data[e.activeTooltipIndex]?.date)} style={{ cursor: "pointer" }} margin={{ top: 20, right: 8, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="aDep" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#34d399" stopOpacity={0.5} /><stop offset="100%" stopColor="#34d399" stopOpacity={0} /></linearGradient>
                <linearGradient id="aWd" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#f87171" stopOpacity={0.5} /><stop offset="100%" stopColor="#f87171" stopOpacity={0} /></linearGradient>
              </defs>
              <CartesianGrid stroke="rgb(var(--t-line))" vertical={false} />
              <XAxis dataKey="label" tick={{ fill: "rgb(var(--t-brand))", fontSize: 12 }} axisLine={false} tickLine={false} />
              <YAxis tickFormatter={short} tick={{ fill: "rgb(var(--t-muted))", fontSize: 11 }} axisLine={false} tickLine={false} width={56} />
              <Tooltip formatter={(v) => inr(v)} labelFormatter={(_, p) => (p?.[0] ? fmtDate(p[0].payload.date) : "")}
                contentStyle={{ background: "rgb(var(--t-surface))", border: "1px solid rgb(var(--t-line2))", borderRadius: 8, color: "rgb(var(--t-ink))" }} />
              <Legend wrapperStyle={{ fontSize: 12, color: "rgb(var(--t-ink2))" }} />
              <Area type="monotone" dataKey="deposit" name="Deposit" stroke="#34d399" strokeWidth={2} fill="url(#aDep)" dot={{ r: 3 }} />
              <Area type="monotone" dataKey="withdraw" name="Withdraw" stroke="#f87171" strokeWidth={2} fill="url(#aWd)" dot={{ r: 3 }} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};
